import React, { useState, useEffect, useContext } from 'react';
import { VendorContext } from '../../providers/Vendor.jsx';
import requests from '../../utils/requests.js';
import { PersonContext } from '../../providers/Person.jsx';
import LabeledInput from '../../common/LabeledInput.jsx';
import StyledInput from '../../common/StyledInput.jsx';
import Images from '../../common/Images.jsx';
import Combos from './Combos.jsx';
import Options from './Options.jsx';
import Tags from './Tags.jsx';

const Item = ({ item, editingItem, setEditingItem }) => {

    const { authorizing, user, auth } = useContext(PersonContext);
    const { vendor, refreshVendor } = useContext(VendorContext);

    return <>

        {!editingItem && <div onClick={() => setEditingItem(item)} style={{
            opacity: item.disabled ? ".5" : "1",
            width: "100%",
            backgroundColor: "#f9f9f9",
            borderLeft: "4px solid " + (item.disabled ? "#ccc" : "rgb(39, 81, 187)"),
            borderRadius: 4,
            boxSizing: "border-box",
            padding: "4px 4px 0 4px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        }}>
            <span style={{ marginBottom: 4, fontSize: 14, display: "block" }}>{item.name}</span>
            <span style={{ marginBottom: 4, fontWeight: "bold", fontSize: 14 }}>${item.price}</span>
        </div>}

        {editingItem && <>

            <div style={{ maxWidth: 500, opacity: editingItem.disabled ? 0.5 : 1 }}>

                <h2 style={{ fontSize: 18, marginBottom: 10 }}><i onClick={() => setEditingItem(null)} className="fas fa-arrow-left" style={{ marginRight: 6, fontSize: 18 }}></i> Edit Item</h2>
                <button style={{ marginBottom: 10, display: "inline-block" }} onClick={() => setEditingItem({ ...editingItem, disabled: !editingItem?.disabled })}>{!editingItem?.disabled ? "Enabled" : "Disabled"}</button>
                {/*duplicate item*/}
                <button style={{ marginBottom: 10, display: "inline-block" }} onClick={async () => {
                    let newId = await requests.addItem(auth, { 
                        name: item.name + " (copy)",
                        tags: item.tags
                     }, vendor.id);
                    await requests.updateItem(auth, { ...item }, vendor.id, newId);
                    refreshVendor();
                    setEditingItem(null);
                }}>Duplicate</button>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 10, width: "100%", boxSizing: "border-box", }}>
                    <StyledInput label="Name" value={editingItem?.name} onChange={e => setEditingItem({ ...editingItem, name: e })} />
                    <StyledInput label="Price" type="number" prefix="$" value={editingItem?.price} onChange={e => setEditingItem({ ...editingItem, price: e })} />
                </div>

                <Tags tags={editingItem?.tags} setTags={e => setEditingItem({ ...editingItem, tags: e })} />
                <StyledInput type="textarea" label="Description" value={editingItem?.description} onChange={e => setEditingItem({ ...editingItem, description: e })} />
                <Images images={editingItem?.images} setImages={e => setEditingItem({ ...editingItem, images: e })} />
                <Combos combos={editingItem?.combos} setCombos={e => setEditingItem({ ...editingItem, combos: e })} />
                <Options options={editingItem?.options} setOptions={e => setEditingItem({ ...editingItem, options: e })} />

            </div>

            {JSON.stringify(editingItem) !== JSON.stringify(item) && <>
                <button onClick={() => setEditingItem(null)}>Cancel</button>
                <button onClick={() => requests.updateItem(auth, { vendorId: vendor.id, ...editingItem }, vendor.id, item.id, refreshVendor)}>Save</button>
            </>}

            <button onClick={() => requests.deleteItem(auth, vendor.id, item.id, () => {
                refreshVendor();
                setEditingItem(null);
            })}>Delete</button>

        </>}

    </>;

}

export default Item;